var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSetupSelectedTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2257 0.78125H2.33681C1.4777 0.78125 0.78125 1.4777 0.78125 2.33681V13.2257C0.78125 14.0848 1.4777 14.7812 2.33681 14.7812H13.2257C14.0848 14.7812 14.7812 14.0848 14.7812 13.2257V2.33681C14.7812 1.4777 14.0848 0.78125 13.2257 0.78125Z",
    stroke: "white",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89062 8.55642L6.22396 10.8898L11.6684 5.44531",
    stroke: "white",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSetupSelectedTick);
export default __webpack_public_path__ + "static/media/profile-setup-selected-tick.f9809bce328e778e7a1e9b55dea52bd8.svg";
export { ForwardRef as ReactComponent };